"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectStyles = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _userflow = _interopRequireDefault(require("../../styles/userflow"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var selectStyles = exports.selectStyles = {
  menu: function menu(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      width: 273,
      overflow: 'hidden',
      margin: '-10px 0 0 0'
    });
  },
  menuList: function menuList(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      maxHeight: 250
    });
  },
  singleValue: function singleValue(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '14px',
      lineHeight: '16px',
      color: _userflow["default"].colors.blue,
      padding: 0,
      margin: 0
    });
  },
  control: function control(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      background: 'none',
      border: 0,
      boxShadow: 'none',
      margin: 0,
      padding: 0,
      cursor: 'pointer'
    });
  },
  valueContainer: function valueContainer(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      padding: 0
    });
  }
};